/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { IWizardExpensesDetailTranslation } from '../../types/wizards/expensesDetail';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardExpensesDetailTranslation: IWizardExpensesDetailTranslation = {
    ...initWizardPropsTranslation,
    formatsAvailable: '',
    hierarchyLevels: '',
    info: '',
    period: '',
    reports: {
        compressionPassword: '',
        destEmailForLink: '',
        needCompression: '',
    },
    sendDocumentTitle: '',
    summaryParams: {
        date: '',
        formatsAvailable: '',
        hierarchyLevels: '',
    },
    validateErrors: {
        default: '',
        selectDate: '',
    },
};
